import { IStyledHr, StyledHr } from 'components/style-components/styled';

export function Hr(props: IStyledHr) {
  return <StyledHr {...props} />;
}
